const LOGIN = '/c/auth/login';
const REGISTER = '/c/auth/register';
const CONFIRM = '/c/auth/confirm/';
const CHECK_ADMISSION = '/c/auth/checkAdmission';
const FORGOT_PASSWORD = '/c/auth/forgotPassword';
const RESET_PASSWORD = '/c/auth/resetPassword/';


const API = {
	LOGIN,
	REGISTER,
	CONFIRM,
	FORGOT_PASSWORD,
	RESET_PASSWORD,
	CHECK_ADMISSION
};

export default API;
